import type { RouteRecordRaw } from 'vue-router'

/** 布局下的子路由（每个导航项对应独立页面） */
export const layoutChildren: RouteRecordRaw[] = [
  {
    path: `/`,
    name: `Home`,
    meta: { title: `首页` },
    component: () => import(`@/views/home/HomePage.vue`),
  },
  {
    path: `/products`,
    name: `Products`,
    meta: { title: `产品介绍` },
    component: () => import(`@/views/products/ProductsPage.vue`),
  },
  {
    path: `/scenarios`,
    name: `Scenarios`,
    meta: { title: `应用场景` },
    component: () => import(`@/views/scenarios/ScenariosPage.vue`),
  },
  {
    path: `/partners`,
    name: `Partners`,
    meta: { title: `合作案例` },
    component: () => import(`@/views/partners/PartnersPage.vue`),
  },
  {
    path: `/news`,
    name: `News`,
    meta: { title: `业务动态` },
    component: () => import(`@/views/news/NewsPage.vue`),
  },
  {
    path: `/news/:id`,
    name: `NewsDetail`,
    meta: { title: `业务动态详情` },
    component: () => import(`@/views/news/NewsDetailPage.vue`),
  },
  {
    path: `/about`,
    name: `About`,
    meta: { title: `关于我们` },
    component: () => import(`@/views/about/AboutPage.vue`),
  },
  {
    path: `/contact`,
    name: `Contact`,
    meta: { title: `合作咨询` },
    component: () => import(`@/views/contact/ContactPage.vue`),
  },
]
